import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=4f4ee848&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=4f4ee848&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ee848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4ee848')) {
      api.createRecord('4f4ee848', component.options)
    } else {
      api.reload('4f4ee848', component.options)
    }
    module.hot.accept("./VideoPlayer.vue?vue&type=template&id=4f4ee848&scoped=true", function () {
      api.rerender('4f4ee848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_v2/VideoPlayer.vue"
export default component.exports